import { createAction } from '@reduxjs/toolkit';

import { IAlert } from './Alert';
import { Banner, IDialog, LoadingToast, PollingEffect, Toast } from './NotificationsService';

const domain = 'teamleader/Services/NotificationsService';

export const actionTypes = {
  ADD_BANNER: `${domain}/ADD_BANNER`,
  CLOSE_FIRST_BANNER: `${domain}/CLOSE_FIRST_BANNER`,
  RESET_BANNERS: `${domain}/RESET_BANNERS`,
  ADD_TOAST: `${domain}/ADD_TOAST`,
  CLOSE_TOAST: `${domain}/CLOSE_TOAST`,
  ADD_LOADING_TOAST: `${domain}/ADD_LOADING_TOAST`,
  CLOSE_LOADING_TOAST: `${domain}/CLOSE_LOADING_TOAST`,
  ADD_DIALOG: `${domain}/ADD_DIALOG`,
  CLOSE_DIALOG: `${domain}/CLOSE_DIALOG`,
  ADD_ALERT: `${domain}/ADD_ALERT`,
  CLOSE_ALERT: `${domain}/CLOSE_ALERT`,
  SET_TOASTS_OFFSET: `${domain}/SET_TOASTS_OFFSET`,
};

export const addBanner = createAction<Banner>(actionTypes.ADD_BANNER);
export const closeFirstBanner = createAction(actionTypes.CLOSE_FIRST_BANNER);
export const resetBanners = createAction(actionTypes.RESET_BANNERS);
export const addToast = createAction(
  actionTypes.ADD_TOAST,
  (
    text: string,
    timeout?: number,
    showCloseButton?: boolean,
    isProcessing?: boolean,
    action?: () => void,
    actionLabel?: string,
  ) => ({
    payload: {
      id: Date.now(),
      text,
      timeout,
      showCloseButton,
      isProcessing,
      action,
      actionLabel,
    } as Toast,
  }),
);
export const closeToast = createAction<number>(actionTypes.CLOSE_TOAST);
export const addLoadingToast = createAction(
  actionTypes.ADD_LOADING_TOAST,
  <P extends Record<string, any>>(text: string, pollResult: PollingEffect<P>, params: P) => ({
    payload: {
      id: Date.now(),
      text,
      pollResult,
      params,
    } as LoadingToast<P>,
  }),
);
export const closeLoadingToast = createAction<number>(actionTypes.CLOSE_LOADING_TOAST);
export const addDialog = createAction<IDialog>(actionTypes.ADD_DIALOG);
export const closeDialog = createAction(actionTypes.CLOSE_DIALOG);
export const addAlert = createAction<IAlert>(actionTypes.ADD_ALERT);
export const closeAlert = createAction(actionTypes.CLOSE_ALERT);
export const setToastsOffset = createAction<number>(actionTypes.SET_TOASTS_OFFSET);

export const actionCreators = {
  addBanner,
  closeFirstBanner,
  resetBanners,
  addToast,
  closeToast,
  addLoadingToast,
  closeLoadingToast,
  addDialog,
  closeDialog,
  addAlert,
  closeAlert,
  setToastsOffset,
};
